import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import PropTypes from 'prop-types';
import * as MobileActions from 'actions/index.ts';
import Util from '../lib/util.js';

import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Public from 'public';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.min.css';

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90%',
  },
});

const imagePattern = /\.(jpeg|jpg|gif|png|bmp|tiff|webp)$/i;

class Download extends Component {
  static propTypes = {
    fileList: PropTypes.array,
  };

  static defaultProps = {
    fileList: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      showLoading: false,
    };
  }

  init() {}

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {}

  handleClose = () => {
    const { actions } = this.props;
    actions.closeDownloadModal();
  };

  view = file => {
    var image = new Image();
    image.src = file.fileUrl;
    var viewer = new Viewer(image, {
      navbar: true,
      toolbar: {
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        prev: false,
        play: true,
        next: false,
        rotateLeft: 4,
        rotateRight: 4,
      },
      hidden: function () {
        viewer.destroy();
      },
    });
    viewer.show();
  };

  download = file => {
    // window.location.href = file.fileUrl;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.style.height = 0;
    iframe.src =
      file.fileUrl + '&response-content-type=application/octet-stream';
    document.body.appendChild(iframe);
    // 30s之后删除
    setTimeout(() => {
      iframe.remove();
    }, 1000);
  };

  render() {
    const { classes, data, fileList } = this.props;
    return (
      <div>
        <Dialog
          classes={{ paper: classes.paper }}
          open={data.downloadModal}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">文件列表</DialogTitle>
          <DialogContent>
            <table className="dialog-file-table">
              <thead>
                <tr>
                  <th className="w60">文件名</th>
                  <th className="w20">大小</th>
                  <th className="w20 tc">操作</th>
                </tr>
              </thead>
              <tbody>
                {fileList.map((file, index) => (
                  <tr key={index}>
                    <td>{file.fileName}</td>
                    <td>
                      {file.sourceType !== 'ERP'
                        ? Util.renderSize(file.fileSize)
                        : ''}
                    </td>
                    <td>
                      {(file.sourceType === 'ERP' ||
                        !file.type ||
                        file.sourceSystem === 2) &&
                        imagePattern.test(file.fileName) && (
                          <Button
                            onClick={() => this.view(file)}
                            color="primary"
                          >
                            查看
                          </Button>
                        )}
                      {/* <a href={file.fileUrl} download>
                        下载
                      </a> */}
                      {(Public.isWeWork || Public.isDingTalk) && (
                        <a onClick={() => this.download(file)}>下载</a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              关闭
            </Button>
          </DialogActions>
        </Dialog>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

Download.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.modal,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Download));
